import React from 'react';
import './Newsletter.css';

const Newsletter = () => {
  return (
    <section className="newsletter">
      <div className="newsletter-container">
        <h2>Join the Cult [of Camo]</h2>
        <div className="social-links">
            <a href="#" className="social-link">Instagram</a>
            <a href="#" className="social-link">X</a>
            <a href="#" className="social-link">TikTok</a>
          </div>
        <div className="newsletter-content">
        <div className="newsletter-cta">
            <button className="cta-button">Submit to Cult Camo</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter; 